import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  @Input() loader: boolean = false;
  @Input() white: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
